// Predictive search: results are server-rendered by sections/predictive-search.liquid via the Section Rendering API.
class PredictiveSearch extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('input[type="search"]');
    this.results = this.querySelector('[data-results]');
    this.cache = new Map();
    this.input.addEventListener('input', () => {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => this.search(this.input.value.trim()), 180);
    });
  }

  clear() {
    clearTimeout(this.timer);
    this.controller?.abort();
    this.results.innerHTML = '';
  }

  async search(terms) {
    this.controller?.abort();
    if (!terms) return this.clear();
    if (this.cache.has(terms)) return (this.results.innerHTML = this.cache.get(terms));

    this.controller = new AbortController();
    const url = new URL(this.dataset.url, location.origin);
    url.searchParams.set('q', terms);
    url.searchParams.set('section_id', 'predictive-search');
    url.searchParams.set('resources[type]', 'product,collection,page');
    url.searchParams.set('resources[limit]', '6');
    url.searchParams.set('resources[options][prefix]', 'last');

    try {
      const res = await fetch(url, { signal: this.controller.signal });
      if (!res.ok) throw new Error(res.status);
      const html = new DOMParser().parseFromString(await res.text(), 'text/html').querySelector('[data-search-results]')?.innerHTML.trim() || '';
      this.cache.set(terms, html);
      if (this.input.value.trim() === terms) this.results.innerHTML = html;
    } catch (err) {
      if (err.name !== 'AbortError') this.results.innerHTML = '';
    }
  }
}

customElements.define('predictive-search', PredictiveSearch);
